<template>
    <Clipboard :data-to-copy="link" id="share_link" class="btn-orange d-flex flex-row mb-3 gap-3 align-items-center">
        <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path d="M13 4.5a2.5 2.5 0 11.702 1.737L6.97 9.604a2.518 2.518 0 010 .792l6.733 3.367a2.5 2.5 0 11-.671 1.341l-6.733-3.367a2.5 2.5 0 110-3.475l6.733-3.366A2.52 2.52 0 0113 4.5z" />
        </svg>
        <span>Copy Link</span>
    </Clipboard>
</template>

<script>
import axios from 'axios'
import Clipboard from './Clipboard.vue'

export default {
    data() {
        return {
            link: "Click to Create Link",
        };
    },
    props: {
        route: {
            type: Object,
            default: () => {
                return {
                    create: null,
                    list: null,
                    link: null,
                };
            },
        },
        definedLink: {
            type: String,
            default: null,
        },
        markup: {
            type: String,
            default: null,
        }
    },
    methods: {
        create() {
            axios.post(this.route.create, {
                markup_id: this.markup
            })
                .then(response => {
                // this.$emit('created', response.data.link)
                this.link = response.data.data.url;
            }).catch(e => console.error(e));
        },
        index() {
            if (this.route.link) {
                this.link = this.route.link;

                return;
            }

            axios.get(`${this.route.list}?markup_id=${this.markup}`)
                .then(response => {
                this.link = response.data.data.url;
            }).catch(e => e);
        }
    },
    mounted() {
        this.index();
    },
    components: { Clipboard }
}
</script>
